import React, {Fragment, useState, useRef} from 'react';
import {Bar, Line, Chart} from 'react-chartjs-2';
import {Section, Explanation_text} from '../../../components';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {connect} from 'react-redux';

function ChartJS(props){
  const[user,setUser]=useState('all');
  const[time_frame, setTimeFrame]=useState('month');
  const[dates_back, setDatesBack]=useState(0);
  let current_time_frame=useRef();
  let current_dates_back=useRef();
  let current_user=useRef();

  if(user!=current_user.current || dates_back!=current_dates_back.current || time_frame!=current_time_frame.current){props.setCreditConsumption(user, dates_back, time_frame); current_user.current=user; current_dates_back.current=dates_back; current_time_frame.current=time_frame;}


  let day_labels=['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
  let week_labels=['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  let month_labels=['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  let year_labels=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  let gmd={};
  //let acd={};
  let swd={};
  let fed={};
  let ead={};
  let evd={};
  let wss={};
  let convd={};
  if(props.credit_consumed){
    for(let cc of props.credit_consumed){
          let time=null;
          if(time_frame=='day'){time=cc.created_at.split('T')[1].split(':')[0]}
          else if(time_frame=='week'){let d=new Date(cc.created_at.split('T')[0].split('-')[0], Number(cc.created_at.split(' ')[0].split('-')[1])-1, cc.created_at.split(' ')[0].split('-')[2]); let w=d.getDay(); let time='Sun'; if(w==1){time='Mon'}else if(w==2){time='Tue';}else if(w==3){time='Wed';}else if(w==4){time='Thu'}else if(w==5){time='Fri'}else if(w==6){time='Sat';}}
          else if(time_frame=='month'){time=cc.created_at.split('T')[0].split('-')[2];}
          if(cc.type=='COMPANY_WEBSITE'){if(swd[time]==undefined){swd[time]=0;} swd[time]=swd[time]+cc.amount;}
          else if(cc.type=='CONVERSION'){if(convd[time]==undefined){convd[time]=0;} convd[time]=convd[time]+cc.amount;}
          //else if(cc.type=='COMPANY'){if(acd[time]==undefined){acd[time]=0;} acd[time]=acd[time]+cc.amount;}
          else if(cc.type=='COMPANY_GOOGLE_MAPS'){if(gmd[time]==undefined){gmd[time]=0;} gmd[time]=gmd[time]+cc.amount;}
          //else if(cc.type=='COMPANY_EMAILS'){if(fed[time]==undefined){fed[time]=0;} fed[time]=fed[time]+cc.amount;}
          else if(cc.type.includes('EMAIL_ENRICHMENT_VERIFY')){if(evd[time]==undefined){evd[time]=0;} evd[time]=evd[time]+cc.amount;}
          else if(cc.type.includes('EMAIL_ENRICHMENT')){if(ead[time]==undefined){ead[time]=0;} ead[time]=ead[time]+cc.amount;}
          else if(cc.type.includes('SPECIAL_SERVICE') && cc.credit_purchase.workspace_default_special_service_id!=null){if(wss[cc.credit_purchase.workspace_default_special_service_id]==undefined){wss[cc.credit_purchase.workspace_default_special_service_id]={}} if(wss[cc.credit_purchase.workspace_default_special_service_id][time]==undefined){wss[cc.credit_purchase.workspace_default_special_service_id][time]=0;} wss[cc.credit_purchase.workspace_default_special_service_id][time]=wss[cc.credit_purchase.workspace_default_special_service_id][time]+cc.amount;}
    }
  }

  let google_maps_data=[];
  //let add_company_data=[];
  let scrape_website_data=[];
  let found_emails_data=[];
  let email_addon_data=[];
  let email_verify_data=[];
  let special_services_data={};
  let conversion_data=[];
  let labels=null; if(time_frame=='day'){labels=day_labels;}else if(time_frame=='week'){labels=week_labels;}else if(time_frame=='month'){labels=month_labels;}

  for(let l of labels){
    if(gmd[l]==undefined){google_maps_data.push(0)}else{google_maps_data.push(gmd[l]);}
    if(fed[l]==undefined){found_emails_data.push(0)}else{found_emails_data.push(fed[l]);}
    if(swd[l]==undefined){scrape_website_data.push(0)}else{scrape_website_data.push(swd[l]);}
    if(ead[l]==undefined){email_addon_data.push(0)}else{email_addon_data.push(ead[l]);}
    if(evd[l]==undefined){email_verify_data.push(0)}else{email_verify_data.push(evd[l]);}
    if(convd[l]==undefined){conversion_data.push(0);}else{conversion_data.push(convd[l]);}
    for(let k in wss){
      if(special_services_data[k]==undefined){special_services_data[k]=[];}
      if(wss[k][l]==undefined){special_services_data[k].push(0)}else{special_services_data[k].push(wss[k][l]);}
    }
  }

  let time_title=''; let date=new Date();
  if(time_frame=='month'){let m=date.getMonth(); let y=date.getFullYear(); let ys=0; if(dates_back>12){ys=Math.floor(dates_back/12);} y=y - ys; m=m - (dates_back - ys*12); if(m<0){m=12 + m; y=y - 1;} time_title=year_labels[m]+' '+y;}
  else if(time_frame=='day'){date.setDate(date.getDate()-dates_back); let m=date.getMonth()+1; let d=date.getDate(); if(d<10){d='0'+d;} if(m<10){m='0'+m;} time_title=d+'/'+m+'/'+date.getFullYear();}
  else if(time_frame=='week'){}

  let data={labels:labels,
            datasets: [
              {label: 'Auto searches', data:google_maps_data, backgroundColor:'rgba(153, 102, 255, 0.9)', borderColor:'rgba(153, 102, 255, 1)', borderWidth: 1, fill:true},
              {label: 'Website scrapes', data:scrape_website_data, backgroundColor:'rgba(75, 192, 192, 0.9)', borderColor:'rgba(75, 192, 192, 1)', borderWidth: 1, fill:true},
              {label: 'Email discovery', data:email_addon_data, backgroundColor:'rgba(255, 99, 71, 0.9)', borderColor:'rgba(255, 99, 71, 1)', borderWidth: 1, fill:true},
              {label: 'Email verifications', data:email_verify_data,  backgroundColor: 'rgba(204, 51, 0, 0.9)', borderColor: 'rgba(204, 51, 0, 1)', borderWidth: 1, fill:true}
            ]
    }

    if(props.workspace!=undefined){for(let wd of props.workspace.defaults){if(wd.special_services.length>0){data.datasets.push({label: 'Converted to JumpStart', data:conversion_data, backgroundColor:'rgba(0, 0, 0, 0.9)', borderColor:'rgba(0, 0, 0, 1)', borderWidth:1, fill:true}); break;}}}


  return(
    <Fragment>
    <Section icon={<MonetizationOnIcon color='primary'/>} title='payment_analytics_credit_usage_title'>
    <div style={{position:'relative', width:'100%', marginTop:'-50px'}}>
    <div>
      <Select
          style={{position:'absolute', right:'20px', width:'150px'}}
          value={user}
          onChange={(e)=>{setUser(e.target.value)}}
        >
          <MenuItem value={'all'}>All</MenuItem>
          {(props.workspace==undefined)?null:Object.keys(props.workspace.user_workspaces).map(function(key){
            let i=props.workspace.user_workspaces[key];
            return(<MenuItem value={i.id}>{i.first_name+' '+i.last_name}</MenuItem>)
          })}
        </Select>
      </div>
      <div>
        <Select
            style={{position:'absolute', right:'190px', width:'150px'}}
            value={time_frame}
            onChange={(e)=>{setDatesBack(0); setTimeFrame(e.target.value)}}
          >
            <MenuItem value='day'>Day</MenuItem>
            <MenuItem value='month'>Month</MenuItem>
          </Select>
       </div>
    </div>
    <div style={{height:'50px'}}/>
    <Typography style={{position:'relative', width:'100%', textAlign:'center'}}><span style={{marginLeft:'20px'}}><IconButton onClick={()=>{setDatesBack(dates_back + 1)}}><ArrowBackIosIcon size='small' color='primary'/></IconButton></span>{time_title}<span style={{marginLeft:'20px'}}><IconButton onClick={()=>{if(dates_back>0){setDatesBack(dates_back - 1)}}}><ArrowForwardIosIcon size='small' color='primary'/></IconButton></span></Typography>
    <div style={{height:'30px'}}/>
    <Line data={data} width={100} height={35} options={{ maintainAspectRatio: true, legend:{display:false}, scales: {y:{stacked: true}}, elements:{point:{radius:0}}}} /></Section>




  {(props.workspace==undefined)?null:props.workspace.defaults.map(function(wd){return(<Fragment>{wd.special_services.map(function(wdss){
    let special_data={
      labels:labels,
      datasets:[]
    }
    if(props.workspace!=undefined){
      for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.id==wdss.id){special_data.datasets.push({label:ss.name+' credits', data:special_services_data[ss.id], backgroundColor:'rgba(0, 0, 0, 0.3)', borderColor:'rgba(0, 0, 0, 1)', borderWidth:1, fill:true})}}}
    }

    return(<Section icon={<img src={wdss.logo} style={{width:'22px'}}/>} title={wdss.name}>
    <div style={{position:'relative', width:'100%', marginTop:'-50px'}}>
    <div>
      <Select
          style={{position:'absolute', right:'20px', width:'150px'}}
          value={user}
          onChange={(e)=>{setUser(e.target.value)}}
        >
          <MenuItem value={'all'}>All</MenuItem>
          {(props.workspace==undefined)?null:Object.keys(props.workspace.user_workspaces).map(function(key){
            let i=props.workspace.user_workspaces[key];
            return(<MenuItem value={i.id}>{i.first_name+' '+i.last_name}</MenuItem>)
          })}
        </Select>
      </div>
      <div>
        <Select
            style={{position:'absolute', right:'190px', width:'150px'}}
            value={time_frame}
            onChange={(e)=>{setDatesBack(0); setTimeFrame(e.target.value)}}
          >
            <MenuItem value='day'>Day</MenuItem>
            <MenuItem value='month'>Month</MenuItem>
          </Select>
       </div>
    </div>
    <div style={{height:'50px'}}/>
    <Typography style={{position:'relative', width:'100%', textAlign:'center'}}><span style={{marginLeft:'20px'}}><IconButton onClick={()=>{setDatesBack(dates_back + 1)}}><ArrowBackIosIcon size='small' color='primary'/></IconButton></span>{time_title}<span style={{marginLeft:'20px'}}><IconButton onClick={()=>{if(dates_back>0){setDatesBack(dates_back - 1)}}}><ArrowForwardIosIcon size='small' color='primary'/></IconButton></span></Typography>
    <div style={{height:'30px'}}/>
    <Line data={special_data} width={100} height={35} options={{ maintainAspectRatio: true, legend:{display:false}, scales: {y:{stacked: true}}, elements:{point:{radius:0}}}} /></Section>

  )})}</Fragment>)})}
    </Fragment>
)
}


export default connect(ss, dd)(ChartJS);

function ss(state){
  return{
    rerender:state.payments.rerender,
    credit_consumed:state.payments.credit_consumption
  }
}

function dd(dispatch){
  return{
    setCreditConsumption:(user_workspace_id, dates_back, time_frame)=>{dispatch({type:'REQUEST_INDEX_CREDIT_CONSUMPTION', user_workspace_id:user_workspace_id, dates_back:dates_back, time_frame:time_frame})}
  }
}
